import client from './client';

const fieldConfigUrl = '/api/v1/sys/field-config';

/**
 * 모듈별 필드 설정 목록 조회
 * @param {string} moduleCd - 모듈 코드 (예: 'CHANCE', 'PROJECT')
 * @returns {Promise} 필드 설정 목록
 */
export const getFieldConfigs = (moduleCd) => {
  return client.get(`${fieldConfigUrl}/list/${moduleCd}`);
};

/**
 * 전체 필드 설정 목록 조회
 * @returns {Promise} 필드 설정 목록
 */
export const getAllFieldConfigs = () => {
  return client.get(`${fieldConfigUrl}/list`);
};

/**
 * 필드 설정 단건 조회
 * @param {string} uuid - 필드 설정 UUID
 * @returns {Promise} 필드 설정
 */
export const getFieldConfigByUuid = (uuid) => {
  return client.get(`${fieldConfigUrl}/detail/${uuid}`);
};

/**
 * 필드 설정 조회 (모듈 + 필드코드)
 * @param {string} moduleCd - 모듈 코드
 * @param {string} fieldCd - 필드 코드
 * @returns {Promise} 필드 설정
 */
export const getFieldConfig = (moduleCd, fieldCd) => {
  return client.get(`${fieldConfigUrl}/detail/${moduleCd}/${fieldCd}`);
};

/**
 * 필드 설정 추가
 * @param {object} data - 필드 설정 정보
 * @returns {Promise} 생성된 필드 설정
 */
export const createFieldConfig = (data) => {
  return client.post(`${fieldConfigUrl}/create`, data);
};

/**
 * 필드 설정 수정
 * @param {string} uuid - 필드 설정 UUID
 * @param {object} data - 수정 내용
 * @returns {Promise} 수정된 필드 설정
 */
export const updateFieldConfig = (uuid, data) => {
  return client.put(`${fieldConfigUrl}/update/${uuid}`, data);
};

/**
 * 필드 설정 일괄 수정
 * @param {array} data - 필드 설정 목록
 * @returns {Promise} 결과
 */
export const updateFieldConfigs = (data) => {
  return client.put(`${fieldConfigUrl}/update/batch`, data);
};

/**
 * 필드 설정 삭제
 * @param {string} uuid - 필드 설정 UUID
 * @returns {Promise} 결과
 */
export const deleteFieldConfig = (uuid) => {
  return client.delete(`${fieldConfigUrl}/delete/${uuid}`);
};
